import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'it',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    resources: {
      it: {
        translation: {
          // Navbar & Links
          navHome: 'Home',
          navRooms: 'Camere',
          navServices: 'Servizi',
          navExperiences: 'Esperienze',
          navGallery: 'Galleria',
          navLocation: 'Posizione',
          navContact: 'Contatti',
          navExternalMap: 'Mappa',
          navConfigurator: 'Configuratore',
          navPrivacyPolicy: 'Privacy Policy',
          navTermsConditions: 'Termini e Condizioni',

          // Nuovo Cookie Banner
          cookieBannerMessage: 'Utilizziamo i cookie per migliorare la tua esperienza. Selezionando "Accetta", acconsenti al loro utilizzo.',
          cookieBannerAccept: 'Accetta',
          cookieBannerDecline: 'Rifiuta',
          cookieBannerPolicyLink: 'Scopri di più',
          
          // Vecchio Cookie Banner (può essere rimosso se non più usato)
          cookieMessage: 'Questo sito utilizza i cookie per garantirti la migliore esperienza.',
          cookieAccept: 'Capito!',

          // Footer
          footerUsefulLinks: 'Link Utili',
          footerContacts: 'Contatti',
          footerYear: 'Anno',

          // Pulsanti Generici
          buttonSeeDetails: 'Vedi Dettagli',
          buttonDiscoverMore: 'Scopri di più',
          buttonSeeAllRooms: 'Vedi Tutte le Camere',
          buttonSeeAllServices: 'Vedi Tutti i Servizi',
          buttonSeeAllExperiences: 'Vedi Tutte le Esperienze',
          buttonContactUs: 'Contattaci Ora',
          buttonCheckAvailability: 'Verifica Disponibilità',
          buttonRequestInfo: 'Richiedi Informazioni',
          buttonConfigureRoom: 'Configura la Camera',
          buttonGetDirections: 'Ottieni Indicazioni',
          buttonCancel: 'Annulla',
          chooseNavigationApp: 'Scegli l\'app di navigazione',

          // Testi Card
          beforeLabel: 'PRIMA',
          afterLabel: 'DOPO',
          startingFromText: 'A Partire da',
          perNightText: 'a Notte',

          // Pagina Contatti
          contactComposeEmail: 'Componi Email di Richiesta',

          // Pagina 404
          notFoundTitle: 'Pagina Non Trovata',
          notFoundText: 'Oops! La pagina che stai cercando non esiste o è stata spostata.',
          notFoundButton: 'Torna alla Home',

          // Mailto Template
          mailtoSubject: 'Richiesta Disponibilità',
          mailtoBody: `
Gentile staff de L'antico Piol De Feltre,

Vorrei richiedere la disponibilità per un soggiorno.

------------------------------------------------

• Camera di interesse: {{room}}
• Quantità di persone: 
• Giorno e ora di check-in: 
• Giorno e ora di check-out: 
• Richieste particolari: 

------------------------------------------------

🕒 Check-in: 16:00 - 20:00 (4:00 PM – 8:00 PM)
🕛 Check-out: 08:00 - 12:00 (9:00 AM – 12:00 AM)`,

          // Room Configuration Page
          roomConfigTitle: 'Configuratore Camera',
          roomConfigDescription: 'Personalizza la tua esperienza scegliendo le opzioni che preferisci',
          configRoomName: 'Camera Desiderata',
          configSelectRoom: 'Seleziona una camera',
          configNumberOfPeople: 'Numero di Persone',
          configExtras: 'Extra / Richieste Particolari',
          configSlippers: 'Ciabattine Disponibili (€5,00 extra)',
          configBedType: 'Tipo di Letti',
          configBedSingle: 'Letti Separati',
          configBedDouble: 'Letto Matrimoniale',
          configCrib: 'Culla per Bambino (€15,00 extra)',
          configPet: 'Ho un Animale Domestico',
          configPetType: 'Tipo di Animale',
          configSelectPetType: 'Seleziona il tipo di animale',
          configErrorSelectPetType: 'Per favore seleziona il tipo di animale.',
          configSelectRoomAlert: 'Seleziona una camera prima di procedere.',
          configPetDog: 'Cane',
          configPetCat: 'Gatto',
          configPetBird: 'Uccello',
          configPetOther: 'Altro',
          configRoomImage: 'Anteprima Camera',
          configEstimatedPrice: 'Prezzo Stimato',
          configSendEmail: 'Invia Richiesta Email',
          configEmailSubject: 'Richiesta Configurazione Camera',
          configSummary: 'Riepilogo Configurazione',
          configAdminUpload: 'Carica Immagine Custom (Admin)',
          configAdminUploading: 'Caricamento...',
          configAdminUploadSuccess: 'Immagine caricata con successo!',
          configAdminUploadError: 'Errore nel caricamento. Riprova.',
          configAdminRemove: 'Ripristina Immagine Predefinita',
          configAdminSelectRoomFirst: 'Seleziona prima una camera per caricare un\'immagine.',
          configEmailBody: `
Gentile staff de L'antico Piol De Feltre,

Ho configurato una camera con le seguenti caratteristiche:

• Date: {{room}}
• Numero di persone: {{people}}
• Tipo di letto: {{bedType}}
• Extra richiesti: {{extras}}
• Culla: {{crib}}
• Animale domestico: {{pet}}
{{petType}}

Vorrei ricevere ulteriori informazioni e disponibilità.

Cordiali saluti`,
        }
      },
      en: {
        translation: {
          // Navbar & Links
          navHome: 'Home',
          navRooms: 'Rooms',
          navServices: 'Services',
          navExperiences: 'Experiences',
          navGallery: 'Gallery',
          navLocation: 'Location',
          navContact: 'Contact',
          navExternalMap: 'Map',
          navConfigurator: 'Configurator',
          navPrivacyPolicy: 'Privacy Policy',
          navTermsConditions: 'Terms & Conditions',

          // New Cookie Banner
          cookieBannerMessage: 'We use cookies to enhance your experience. By selecting "Accept", you consent to their use.',
          cookieBannerAccept: 'Accept',
          cookieBannerDecline: 'Decline',
          cookieBannerPolicyLink: 'Learn more',

          // Old Cookie Banner
          cookieMessage: 'This website uses cookies to ensure you get the best experience.',
          cookieAccept: 'Got it!',

          // Footer
          footerUsefulLinks: 'Useful Links',
          footerContacts: 'Contacts',
          footerYear: 'Year',

          // Generic Buttons
          buttonSeeDetails: 'See Details',
          buttonDiscoverMore: 'Discover More',
          buttonSeeAllRooms: 'See All Rooms',
          buttonSeeAllServices: 'See All Services',
          buttonSeeAllExperiences: 'See All Experiences',
          buttonContactUs: 'Contact Us Now',
          buttonCheckAvailability: 'Check Availability',
          buttonRequestInfo: 'Request Information',
          buttonConfigureRoom: 'Configure Room',
          buttonGetDirections: 'Get Directions',
          buttonCancel: 'Cancel',
          chooseNavigationApp: 'Choose navigation app',

          // Card Texts
          beforeLabel: 'BEFORE',
          afterLabel: 'AFTER',
          startingFromText: 'Starting from',
          perNightText: 'per night',

          // Contact Page
          contactComposeEmail: 'Compose Request Email',
          
          // 404 Page
          notFoundTitle: 'Page Not Found',
          notFoundText: 'Oops! The page you are looking for does not exist or has been moved.',
          notFoundButton: 'Back to Home',

          // Mailto Template
          mailtoSubject: 'Availability Request',
          mailtoBody: `
Dear staff of L'antico Piol De Feltre,

I would like to request availability for a stay.

------------------------------------------------

• Room of interest: {{room}}
• Number of people: 
• Check-in date and time: 
• Check-out date and time: 
• Special requests: 

------------------------------------------------

🕒 Check-in: 16:00 - 20:00 (4:00 PM – 8:00 PM)
🕛 Check-out: 08:00 - 12:00 (8:00 AM – 12:00 AM)`,

          // Room Configuration Page
          roomConfigTitle: 'Room Configurator',
          roomConfigDescription: 'Customize your experience by choosing your preferred options',
          configRoomName: 'Desired Room',
          configSelectRoom: 'Select a room',
          configNumberOfPeople: 'Number of People',
          configExtras: 'Extras / Special Requests',
          configSlippers: 'Available Slippers (€5.00 extra)',
          configBedType: 'Bed Type',
          configBedSingle: 'Separate Beds',
          configBedDouble: 'Double Bed',
          configCrib: 'Baby Crib (€15.00 extra)',
          configPet: 'I Have a Pet',
          configPetType: 'Type of Pet',
          configSelectPetType: 'Select pet type',
          configErrorSelectPetType: 'Please select the type of pet.',
          configSelectRoomAlert: 'Please select a room before proceeding.',
          configPetDog: 'Dog',
          configPetCat: 'Cat',
          configPetBird: 'Bird',
          configPetOther: 'Other',
          configRoomImage: 'Room Preview',
          configEstimatedPrice: 'Estimated Price',
          configSendEmail: 'Send Request Email',
          configEmailSubject: 'Room Configuration Request',
          configSummary: 'Configuration Summary',
          configAdminUpload: 'Upload Custom Image (Admin)',
          configAdminUploading: 'Uploading...',
          configAdminUploadSuccess: 'Image uploaded successfully!',
          configAdminUploadError: 'Upload error. Please try again.',
          configAdminRemove: 'Restore Default Image',
          configAdminSelectRoomFirst: 'Please select a room first to upload an image.',
          configEmailBody: `
Dear staff of L'antico Piol De Feltre,

I have configured a room with the following features:

• Dates: {{room}}
• Number of people: {{people}}
• Bed type: {{bedType}}
• Extra requests: {{extras}}
• Crib: {{crib}}
• Pet: {{pet}}
{{petType}}

I would like to receive further information and availability.

Best regards`,
        }
      },
      de: {
        translation: {
          // Navbar & Links
          navHome: 'Startseite',
          navRooms: 'Zimmer',
          navServices: 'Dienstleistungen',
          navExperiences: 'Erlebnisse',
          navGallery: 'Galerie',
          navLocation: 'Standort',
          navContact: 'Kontakt',
          navConfigurator: 'Konfigurator',
          navExternalMap: 'Karte',
          navPrivacyPolicy: 'Datenschutz',
          navTermsConditions: 'AGB',

          // New Cookie Banner
          cookieBannerMessage: 'Wir verwenden Cookies, um Ihre Erfahrung zu verbessern. Mit der Auswahl "Akzeptieren" stimmen Sie deren Verwendung zu.',
          cookieBannerAccept: 'Akzeptieren',
          cookieBannerDecline: 'Ablehnen',
          cookieBannerPolicyLink: 'Mehr erfahren',

          // Old Cookie Banner
          cookieMessage: 'Diese Website verwendet Cookies, um Ihnen das beste Erlebnis zu garantieren.',
          cookieAccept: 'Verstanden!',

          // Footer
          footerUsefulLinks: 'Nützliche Links',
          footerContacts: 'Kontakte',
          footerYear: 'Jahr',

          // Generic Buttons
          buttonSeeDetails: 'Details ansehen',
          buttonDiscoverMore: 'Mehr entdecken',
          buttonGetDirections: 'Route berechnen',
          buttonSeeAllRooms: 'Alle Zimmer ansehen',
          buttonSeeAllServices: 'Alle Dienstleistungen ansehen',
          buttonSeeAllExperiences: 'Alle Erlebnisse ansehen',
          buttonContactUs: 'Kontaktieren Sie uns jetzt',
          buttonCheckAvailability: 'Verfügbarkeit prüfen',
          buttonRequestInfo: 'Informationen anfordern',
          buttonConfigureRoom: 'Zimmer konfigurieren',
          buttonCancel: 'Abbrechen',
          chooseNavigationApp: 'Navigations-App wählen',
          
          // Card Texts
          beforeLabel: 'VORHER',
          afterLabel: 'NACHHER',
          startingFromText: 'Ab',
          perNightText: 'pro Nacht',

          // Contact Page
          contactComposeEmail: 'Anfrage-E-Mail verfassen',

          // 404 Page
          notFoundTitle: 'Seite nicht gefunden',
          notFoundText: 'Hoppla! Die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben.',
          notFoundButton: 'Zurück zur Startseite',

          // Mailto Template
          mailtoSubject: 'Verfügbarkeitsanfrage',
          mailtoBody: `
Sehr geehrtes Team von L'antico Piol De Feltre,

ich möchte die Verfügbarkeit für einen Aufenthalt anfragen.

------------------------------------------------

• Interessierendes Zimmer: {{room}}
• Personenanzahl: 
• Datum und Uhrzeit des Einchecks: 
• Datum und Uhrzeit des Auschecks: 
• Besondere Anfragen: 

------------------------------------------------

🕒 Check-in: 16:00 - 20:00 (4:00 PM – 8:00 PM)
🕛 Check-out: 08:00 - 12:00 (8:00 AM – 12:00 AM)`,

          // Room Configuration Page
          roomConfigTitle: 'Zimmer-Konfigurator',
          roomConfigDescription: 'Personalisieren Sie Ihre Erfahrung, indem Sie Ihre bevorzugten Optionen auswählen',
          configRoomName: 'Gewünschtes Zimmer',
          configSelectRoom: 'Wählen Sie ein Zimmer',
          configNumberOfPeople: 'Anzahl der Personen',
          configExtras: 'Extras / Besondere Anfragen',
          configSlippers: 'Verfügbare Hausschuhe (€5,00 extra)',
          configBedType: 'Betttyp',
          configBedSingle: 'Getrennte Betten',
          configBedDouble: 'Doppelbett',
          configCrib: 'Babybett (€15,00 extra)',
          configPet: 'Ich habe ein Haustier',
          configPetType: 'Art des Haustieres',
          configSelectPetType: 'Haustiertyp wählen',
          configErrorSelectPetType: 'Bitte wählen Sie die Art des Haustieres.',
          configSelectRoomAlert: 'Bitte wählen Sie ein Zimmer, bevor Sie fortfahren.',
          configPetDog: 'Hund',
          configPetCat: 'Katze',
          configPetBird: 'Vogel',
          configPetOther: 'Sonstiges',
          configRoomImage: 'Zimmervorschau',
          configEstimatedPrice: 'Geschätzter Preis',
          configSendEmail: 'Anfrage-E-Mail senden',
          configEmailSubject: 'Zimmer-Konfigurationsanfrage',
          configSummary: 'Konfigurationsübersicht',
          configAdminUpload: 'Benutzerdefiniertes Bild hochladen (Admin)',
          configAdminUploading: 'Wird hochgeladen...',
          configAdminUploadSuccess: 'Bild erfolgreich hochgeladen!',
          configAdminUploadError: 'Fehler beim Hochladen. Bitte versuchen Sie es erneut.',
          configAdminRemove: 'Standardbild wiederherstellen',
          configAdminSelectRoomFirst: 'Bitte wählen Sie zuerst ein Zimmer aus, um ein Bild hochzuladen.',
          configEmailBody: `
Sehr geehrtes Team von L'antico Piol De Feltre,

ich habe ein Zimmer mit folgenden Eigenschaften konfiguriert:

• Daten: {{room}}
• Anzahl der Personen: {{people}}
• Betttyp: {{bedType}}
• Besondere Anfragen: {{extras}}
• Babybett: {{crib}}
• Haustier: {{pet}}
{{petType}}

Ich möchte weitere Informationen und Verfügbarkeit erhalten.

Mit freundlichen Grüßen`,
        }
      },
      nl: {
        translation: {
          // Navbar & Links
          navHome: 'Home',
          navRooms: 'Kamers',
          navServices: 'Diensten',
          navExperiences: 'Ervaringen',
          navGallery: 'Galerij',
          navLocation: 'Locatie',
          navContact: 'Contact',
          navConfigurator: 'Configurator',
          navExternalMap: 'Kaart',
          navPrivacyPolicy: 'Privacybeleid',
          navTermsConditions: 'Algemene Voorwaarden',

          // New Cookie Banner
          cookieBannerMessage: 'Wij gebruiken cookies om uw ervaring te verbeteren. Door "Accepteren" te selecteren, stemt u in met het gebruik ervan.',
          cookieBannerAccept: 'Accepteren',
          cookieBannerDecline: 'Weigeren',
          cookieBannerPolicyLink: 'Meer informatie',

          // Old Cookie Banner
          cookieMessage: 'Deze website maakt gebruik van cookies om u de beste ervaring te garanderen.',
          cookieAccept: 'Begrepen!',

          // Footer
          footerUsefulLinks: 'Handige Links',
          footerContacts: 'Contacten',
          footerYear: 'Jaar',

          // Generic Buttons
          buttonGetDirections: 'Routebeschrijving',
          buttonSeeDetails: 'Bekijk Details',
          buttonDiscoverMore: 'Ontdek meer',
          buttonSeeAllRooms: 'Alle kamers bekijken',
          buttonSeeAllServices: 'Alle diensten bekijken',
          buttonSeeAllExperiences: 'Alle ervaringen bekijken',
          buttonContactUs: 'Neem contact op',
          buttonCheckAvailability: 'Beschikbaarheid controleren',
          buttonRequestInfo: 'Informatie aanvragen',
          buttonConfigureRoom: 'Kamer configureren',
          buttonCancel: 'Annuleren',
          chooseNavigationApp: 'Kies navigatie-app',
          
          // Card Texts
          beforeLabel: 'VOOR',
          afterLabel: 'NA',
          startingFromText: 'Vanaf',
          perNightText: 'per nacht',

          // Contact Page
          contactComposeEmail: 'Verzoek-e-mail opstellen',

          // 404 Page
          notFoundTitle: 'Pagina niet gevonden',
          notFoundText: 'Oeps! De pagina die u zoekt bestaat niet of is verplaatst.',
          notFoundButton: 'Terug naar Home',

          // Mailto Template
          mailtoSubject: 'Beschikbaarheidsaanvraag',
          mailtoBody: `
Geacht team van L'antico Piol De Feltre,

Ik wil graag de beschikbaarheid voor een verblijf aanvragen.

------------------------------------------------

• Kamer van belang: {{room}}
• Aantal personen: 
• Datum en tijd van inchecken: 
• Datum en tijd van uitchecken: 
• Speciale verzoeken: 

------------------------------------------------

🕒 Check-in: 16:00 - 20:00 (4:00 PM – 8:00 PM)
🕛 Check-out: 08:00 - 12:00 (8:00 AM – 12:00 AM)`,

          // Room Configuration Page
          roomConfigTitle: 'Kamerconfiguratie',
          roomConfigDescription: 'Personaliseer uw ervaring door uw favoriete opties te kiezen',
          configRoomName: 'Gewenste Kamer',
          configSelectRoom: 'Selecteer een kamer',
          configNumberOfPeople: 'Aantal personen',
          configExtras: 'Extra\'s / Speciale Verzoeken',
          configSlippers: 'Beschikbare Slippers (€5,00 extra)',
          configBedType: 'Bedtype',
          configBedSingle: 'Aparte Bedden',
          configBedDouble: 'Tweepersoonsbed',
          configCrib: 'Babybed (€15,00 extra)',
          configPet: 'Ik heb een huisdier',
          configPetType: 'Soort huisdier',
          configSelectPetType: 'Selecteer huisdiersoort',
          configErrorSelectPetType: 'Selecteer alstublieft de soort huisdier.',
          configSelectRoomAlert: 'Selecteer alstublieft een kamer voordat u doorgaat.',
          configPetDog: 'Hond',
          configPetCat: 'Kat',
          configPetBird: 'Vogel',
          configPetOther: 'Overig',
          configRoomImage: 'Kamervoorbeeld',
          configEstimatedPrice: 'Geschatte Prijs',
          configSendEmail: 'Verzend aanvraagemail',
          configEmailSubject: 'Verzoek kamerconfiguratie',
          configSummary: 'Configuratie-overzicht',
          configAdminUpload: 'Aangepaste afbeelding uploaden (Admin)',
          configAdminUploading: 'Uploaden...',
          configAdminUploadSuccess: 'Afbeelding succesvol geüpload!',
          configAdminUploadError: 'Fout bij uploaden. Probeer het opnieuw.',
          configAdminRemove: 'Standaardafbeelding herstellen',
          configAdminSelectRoomFirst: 'Selecteer eerst een kamer om een afbeelding te uploaden.',
          configEmailBody: `
Geacht team van L'antico Piol De Feltre,

Ik heb een kamer geconfigureerd met de volgende kenmerken:

• Data: {{room}}
• Aantal personen: {{people}}
• Bedtype: {{bedType}}
• Speciale verzoeken: {{extras}}
• Babybed: {{crib}}
• Huisdier: {{pet}}
{{petType}}

Ik zou graag meer informatie en beschikbaarheid ontvangen.

Met vriendelijke groeten`,
        }
      },
      fr: {
        translation: {
          // Navbar & Links
          navHome: 'Accueil',
          navRooms: 'Chambres',
          navServices: 'Services',
          navExperiences: 'Expériences',
          navGallery: 'Galerie',
          navLocation: 'Emplacement',
          navConfigurator: 'Configurateur',
          navContact: 'Contact',
          navExternalMap: 'Carte',
          navPrivacyPolicy: 'Politique de Confidentialité',
          navTermsConditions: 'Termes et Conditions',

          // New Cookie Banner
          cookieBannerMessage: 'Nous utilisons des cookies pour améliorer votre expérience. En sélectionnant "Accepter", vous consentez à leur utilisation.',
          cookieBannerAccept: 'Accepter',
          cookieBannerDecline: 'Refuser',
          cookieBannerPolicyLink: 'En savoir plus',
          
          // Old Cookie Banner
          cookieMessage: 'Ce site Web utilise des cookies pour vous garantir la meilleure expérience.',
          cookieAccept: 'Compris !',

          // Footer
          footerUsefulLinks: 'Liens Utiles',
          footerContacts: 'Contacts',
          footerYear: 'Année',

          // Generic Buttons
          buttonSeeDetails: 'Voir les détails',
          buttonDiscoverMore: 'Découvrir plus',
          buttonSeeAllRooms: 'Voir toutes les chambres',
          buttonSeeAllServices: 'Voir tous les services',
          buttonSeeAllExperiences: 'Voir toutes les expériences',
          buttonContactUs: 'Nous contacter',
          buttonCheckAvailability: 'Vérifier la disponibilité',
          buttonRequestInfo: 'Demander des informations',
          buttonConfigureRoom: 'Configurer la chambre',
          buttonGetDirections: 'Obtenir les indications',
          buttonCancel: 'Annuler',
          chooseNavigationApp: 'Choisir l\'application de navigation',

          // Card Texts
          beforeLabel: 'AVANT',
          afterLabel: 'APRÈS',
          startingFromText: 'À partir de',
          perNightText: 'par nuit',

          // Contact Page
          contactComposeEmail: 'Composer un e-mail de demande',

          // 404 Page
          notFoundTitle: 'Page non trouvée',
          notFoundText: 'Oops! La page que vous recherchez n\'existe pas ou a été déplacée.',
          notFoundButton: 'Retour à l\'accueil',

          // Mailto Template
          mailtoSubject: 'Demande de Disponibilité',
          mailtoBody: `
Chère équipe de L'antico Piol De Feltre,

Je voudrais demander la disponibilité pour un séjour.

------------------------------------------------

• Chambre d'intérêt : {{room}}
• Nombre de personnes : 
• Date et heure d'arrivée : 
• Date et heure de départ : 
• Demandes particulières :

------------------------------------------------

🕒 Check-in: 16:00 - 20:00 (4:00 PM – 8:00 PM)
🕛 Check-out: 08:00 - 12:00 (8:00 AM – 12:00 AM)`,

          // Room Configuration Page
          roomConfigTitle: 'Configurateur de Chambre',
          roomConfigDescription: 'Personnalisez votre expérience en choisissant les options que vous préférez',
          configRoomName: 'Chambre Souhaitée',
          configSelectRoom: 'Sélectionnez une chambre',
          configNumberOfPeople: 'Nombre de personnes',
          configExtras: 'Suppléments / Demandes Spéciales',
          configSlippers: 'Pantoufles disponibles (€5,00 supplémentaires)',
          configBedType: 'Type de Lit',
          configBedSingle: 'Lits Séparés',
          configBedDouble: 'Lit Double',
          configCrib: 'Lit Bébé (€15,00 supplémentaires)',
          configPet: 'Je possède un animal de compagnie',
          configPetType: 'Type d\'animal',
          configSelectPetType: 'Sélectionnez le type d\'animal',
          configErrorSelectPetType: 'Veuillez sélectionner le type d\'animal.',
          configSelectRoomAlert: 'Veuillez sélectionner une chambre avant de continuer.',
          configPetDog: 'Chien',
          configPetCat: 'Chat',
          configPetBird: 'Oiseau',
          configPetOther: 'Autre',
          configRoomImage: 'Aperçu de la chambre',
          configEstimatedPrice: 'Prix Estimé',
          configSendEmail: 'Envoyer un email de demande',
          configEmailSubject: 'Demande de configuration de chambre',
          configSummary: 'Résumé de la Configuration',
          configAdminUpload: 'Télécharger une image personnalisée (Admin)',
          configAdminUploading: 'Téléchargement...',
          configAdminUploadSuccess: 'Image téléchargée avec succès !',
          configAdminUploadError: 'Erreur de téléchargement. Veuillez réessayer.',
          configAdminRemove: 'Restaurer l\'image par défaut',
          configAdminSelectRoomFirst: 'Veuillez d\'abord sélectionner une chambre pour télécharger une image.',
          configEmailBody: `
Chère équipe de L'antico Piol De Feltre,

J'ai configuré une chambre avec les caractéristiques suivantes:

• Dates: {{room}}
• Nombre de personnes : {{people}}
• Type de lit: {{bedType}}
• Demandes spéciales : {{extras}}
• Lit bébé : {{crib}}
• Animal de compagnie : {{pet}}
{{petType}}

J'aimerais recevoir plus d'informations et des disponibilités.

Cordialement`,
        }
      }
    }
  });

export default i18n;